import { useEffect, useState } from "react";
import HomeSectionModel from "../Models/PlaylistModel";
import API_ROUTES from "./apiRoutes";
import { useFetch } from './useFetch';

export const usePlaylists = () => {
    const [playlists, setPlaylists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getToken = () => localStorage.getItem("token");
    const { fetchWithAuth } = useFetch();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchWithAuth(API_ROUTES.HOME.list(), {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${getToken()}`,
                        "Content-Type": "application/json",
                    }
                })
                const data = await response.json()
                const model = data.sections.map(
                    (item) => new HomeSectionModel(item)
                );

                setPlaylists(model)
            } catch (err) {
                console.error('Error fetching playlists:', err);
                setError(err.message || "Erro ao carregar playlists");
            } finally {
                setLoading(false);
            }
        }

        fetchData()
    }, []);

    return { playlists, loading, error };
}